import { styled, Box } from '@mui/material';

export const TablePaginationContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
});
